import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Listings from './pages/Listings';
import Portfoyler from './pages/Portfoyler';
import Messages from './pages/Messages';
import SosyalMedya from './pages/SosyalMedya';
import Login from './pages/Login';

function Nav({ setToken }) {
  return (
    <nav className='main-nav' style={{ background:'#1e293b', padding:'0 24px', display:'flex', alignItems:'center', gap:8, height:56 }}>
      <span style={{ color:'#3b82f6', fontWeight:700, fontSize:18, marginRight:24 }}>🏠 Prestij CRM</span>
      {[['/', 'Dashboard'], ['/customers', 'Müşteriler'], ['/listings', 'İlanlar'], ['/portfoyler', 'Portföyler'], ['/messages', 'WhatsApp'], ['/sosyal-medya', 'Sosyal Medya']].map(([path, label]) => (
        <NavLink key={path} to={path} end={path==='/'} style={({ isActive }) => ({ color: isActive ? '#3b82f6' : '#94a3b8', textDecoration:'none', padding:'6px 12px', borderRadius:6, fontWeight:500, fontSize:14 })}>
          {label}
        </NavLink>
      ))}
      <button onClick={() => { localStorage.removeItem('token'); setToken(null); }} style={{ marginLeft:'auto', background:'#ef4444', color:'#fff', border:'none', borderRadius:6, padding:'6px 14px', cursor:'pointer', fontSize:14, fontWeight:600 }}>Çıkış</button>
    </nav>
  );
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  if (!token) return <Login setToken={setToken} />;
  return (
    <BrowserRouter>
      <Nav setToken={setToken} />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/portfoyler" element={<Portfoyler />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/sosyal-medya" element={<SosyalMedya />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
